export default __webpack_public_path__ + "static/media/yammer.f04e3de1.svg";